var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCandea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 369.65712,-2.952 c 3.96,2.232 8.424,3.312 13.392,3.312 3.60001,0 6.912,-0.576 10.008,-1.8 3.096,-1.152 5.76001,-2.952 7.92,-5.256 l -2.30399,-2.376 c -4.10401,4.032 -9.288,6.048 -15.48001,6.048 -4.24799,0 -8.064,-0.936 -11.51999,-2.88 -3.45601,-1.872 -6.192,-4.536 -8.13601,-7.92 -2.016,-3.384 -2.952,-7.2 -2.952,-11.376 0,-4.176 0.936,-7.92 2.952,-11.304 1.94401,-3.384 4.68,-6.048 8.13601,-7.992 3.45599,-1.872 7.272,-2.88 11.51999,-2.88 6.26401,0 11.448,2.016 15.48001,5.976 l 2.30399,-2.376 c -2.15999,-2.304 -4.824,-4.032 -7.848,-5.184 -3.096,-1.152 -6.47999,-1.8 -10.08,-1.8 -4.968,0 -9.432,1.152 -13.392,3.312 -3.95999,2.232 -7.05599,5.256 -9.36,9.144 -2.30399,3.888 -3.384,8.28 -3.384,13.104 0,4.896 1.08001,9.216 3.384,13.104 2.30401,3.888 5.40001,6.984 9.36,9.144 z",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    fill: "#161616",
    stroke: "#161616",
    transform: "translate(50 2.32) scale(2.3333333333333335) translate(-356.91312 50.76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 430.37225,-50.4 h -3.672 L 403.51625,0 h 3.96 l 21.024,-46.368 21.096,46.368 h 3.96 z",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    fill: "#3a393a",
    stroke: "#3a393a",
    transform: "translate(158.74063666666666 3.16) scale(2.3333333333333335) translate(-403.51625 50.4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 503.74587,-50.4 h -3.672 v 43.776 l -34.272,-43.776 h -3.096 V 0 h 3.67201 V -43.776 L 500.72187,0 h 3.024 z",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    fill: "#5d5d5f",
    stroke: "#5d5d5f",
    transform: "translate(296.8497499999999 3.16) scale(2.3333333333333335) translate(-462.70587 50.4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 564.6905,-38.16 c -2.304,-3.816 -5.472,-6.768 -9.504,-9 -4.032,-2.16 -8.712,-3.24 -13.896,-3.24 h -19.944 v 3.312 h 19.656 c 4.608,0 8.712,0.936 12.312,2.808 3.528,1.872 6.264,4.464 8.208,7.704 1.872,3.312 2.88,7.128 2.88,11.376 0,4.32 -1.008,8.064 -2.88,11.376 -1.944,3.312 -4.68,5.904 -8.208,7.776 -3.6,1.872 -7.704,2.736 -12.312,2.736 h -15.984 V -25.2 h -3.672 V 0 h 19.944 c 5.184,0 9.864,-1.08 13.896,-3.24 4.032,-2.16 7.2,-5.112 9.504,-8.928 2.232,-3.816 3.384,-8.136 3.384,-13.032 0,-4.824 -1.152,-9.144 -3.384,-12.96 z",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    fill: "#818083",
    stroke: "#818083",
    transform: "translate(433.6778866666665 3.16) scale(2.3333333333333335) translate(-521.3465 50.4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 613.44687,-27.216 h -32.616 v 3.24 h 32.616 z m 0,-23.184 h -32.616 v 3.312 h 32.616 z m -32.616,47.088 V 0 h 32.616 v -3.312 z",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    fill: "#a4a4a8",
    stroke: "#a4a4a8",
    transform: "translate(572.47475 3.16) scale(2.3333333333333335) translate(-580.83087 50.4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 647.49725,-50.4 h -3.672 L 620.64125,0 h 3.96 l 21.024,-46.368 21.096,46.368 h 3.96 z",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    fill: "#c8c7cc",
    stroke: "#c8c7cc",
    transform: "translate(665.3656366666668 3.16) scale(2.3333333333333335) translate(-620.64125 50.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandea);
export default __webpack_public_path__ + "static/media/candea.40d423a1201e1e6bc742ce971ebd3368.svg";
export { ForwardRef as ReactComponent };